<template>
  <div class="message">
    <div class="message-box">
      <!-- <img
        src="http://yinzhilv-front-admin-bucket.oss-cn-beijing.aliyuncs.com/default-v2/distributor/registration%20success.png?x-oss-process=style/webp"
        alt=""
      >-->
      <div class="message_text flex-center">
        <div class="message-icon">
          <span>
            <i class="el-icon-check"></i>
          </span>
        </div>
        <div>
          <span :class="{'sucText':type==1}">{{type==0?'充值成功':'充值失败'}}</span>
          <!-- <span @click="$router.push({name:'distributor-account-deposit'})">继续充值</span> -->
          <div class="flex-center" style="margin-top:10px">
            <!-- <el-button
              type="success"
              size="small"
              @click="$router.push({name:'distributor-yinqianbao-back-account-management'})"
            >前往预存款管理</el-button>-->
            <div
              class="message_btn blue"
              @click="$router.push({name:'distributor-yinqianbao-back-account-management'})"
            >前往余额账户管理</div>
            <div
              class="message_btn default"
              @click="$router.push({name:'distributor-account-deposit'})"
            >继续充值</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "message",
  data() {
    return {
      type: this.$route.query.type || 0
    };
  },

  methods: {}
};
</script>
<style lang="less" scoped>
.message {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 100px;
  .message-box {
    width: 70%;
    display: flex;
    img {
      width: 450px;
      height: 450px;
    }
    .message_text {
      width: 100%;
      span:nth-child(1) {
        font-size: 18px;
        color: #237dc9;
        letter-spacing: 3px;
        font-weight: 400;
      }
      .sucText {
        color: #f56c6c !important;
      }
      span:nth-child(2) {
        font-size: 13px;
        color: #0462af;
        cursor: pointer;
        padding-left: 100px;
      }
      p {
        font-size: 13px;
        text-align: center;
        color: #333;
        padding: 30px 0;
      }
    }
  }
  .message_btn {
    padding: 8px 20px;
    border: 1px solid #237dc9;
    border-radius: 4px;
    font-size: 12px !important;
    margin-right: 10px;
    cursor: pointer;
    font-weight: bold;
  }
  .blue {
    color: white !important;
    background: #237dc9;
    &:hover {
      background: #2a8ddf;
    }
  }
  .default {
    color: #237dc9;
    background: white;
    &:hover {
      background: #f9f9f9;
    }
  }
  .message-icon {
    margin-right: 30px;
    span {
      display: block;
      width: 70px;
      height: 70px;
      border-radius: 50%;
      border: 4px solid #58ca18;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    i {
      font-size: 47px;
      color: #58ca18;
    }
  }
}
.el-button {
  border-radius: 0;
}
</style>